import { useState } from 'react';

const inferMediaType = (mediaType, mediaUrl) => {
  const normalizedType = String(mediaType || '').toLowerCase();
  if (normalizedType === 'video' || normalizedType === 'image') return normalizedType;
  const normalizedUrl = String(mediaUrl || '').toLowerCase();
  if (normalizedUrl.endsWith('.mp4') || normalizedUrl.endsWith('.mov') || normalizedUrl.endsWith('.webm')) {
    return 'video';
  }
  return 'image';
};

export const BlogMediaRenderer = ({
  mediaUrl,
  mediaType,
  alt,
  variant = 'hero',
  imageClassName = 'w-full h-full object-cover',
  videoClassName = 'w-full h-full object-cover',
  testIdPrefix = 'blog-media',
}) => {
  const [isPortraitVideo, setIsPortraitVideo] = useState(false);
  const resolvedType = inferMediaType(mediaType, mediaUrl);

  if (!mediaUrl) return null;

  if (resolvedType === 'video') {
    const portraitClasses = variant === 'card'
      ? 'h-full w-auto max-w-[180px] mx-auto object-contain'
      : 'h-full w-auto max-w-[420px] mx-auto object-contain';

    const computedVideoClass = isPortraitVideo ? portraitClasses : videoClassName;

    return (
      <div className="h-full w-full bg-black" data-testid={`${testIdPrefix}-video-wrap`}>
        <video
          controls
          className={computedVideoClass}
          data-testid={`${testIdPrefix}-video-player`}
          onLoadedMetadata={(event) => {
            const target = event.currentTarget;
            if (target.videoWidth > 0 && target.videoHeight > 0) {
              setIsPortraitVideo(target.videoHeight > target.videoWidth);
            }
          }}
        >
          <source src={mediaUrl} />
        </video>
      </div>
    );
  }

  return <img src={mediaUrl} alt={alt} className={imageClassName} data-testid={`${testIdPrefix}-image`} />;
};
